module.exports = __webpack_public_path__ + "static/iphone-8c1d14f3e7c84cb9f08ca8edd3661bd6.png";